import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiBlockContentComponent } from './eui-block-content.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiBlockContentComponent],
    declarations: [EuiBlockContentComponent]
})
export class EuiBlockContentComponentModule {
}
